
<section class="pl-hero">
  <div class="pl-hero-inner">
    <p class="pl-eyebrow">EXECUTION PARTNERS</p>
    <h1 class="pl-hero-title">AI gets it to 70%.<br />You get paid to finish it.</h1>
    <p class="pl-hero-sub">
      Angularize funds real projects and lets AI draft the first build.
      Execution Partners — developers, designers, QA, and product managers —
      pick up the scoped, already-funded work that's left and take it to
      done. Fixed price per story point. No bidding wars, no cold outreach,
      no chasing invoices.
    </p>
    <div class="pl-hero-actions">
      <a routerLink="apply" class="pl-btn pl-btn-primary">
        Become an Execution Partner
        <mat-icon>arrow_forward</mat-icon>
      </a>
      <a href="#pl-roles" class="pl-btn pl-btn-ghost">See open roles</a>
    </div>
  </div>
</section>
<app-partner-status-banner></app-partner-status-banner>


<section class="pl-how">
  <div class="pl-section-inner">
    <p class="pl-eyebrow pl-eyebrow-dark">HOW IT WORKS</p>
    <h2 class="pl-section-title">From application to payout.</h2>
    <div class="pl-how-grid">
      <div class="pl-how-card">
        <span class="pl-how-num">01</span>
        <h3>Apply</h3>
        <p>
          Tell us about your work — real links, real projects, not just a
          checklist of skills.
        </p>
      </div>
      <div class="pl-how-card">
        <span class="pl-how-num">02</span>
        <h3>Get approved</h3>
        <p>
          Every application is reviewed by hand. Not everyone gets in —
          that's what makes "vetted" mean something to the buyers paying for
          it.
        </p>
      </div>
      <div class="pl-how-card">
        <span class="pl-how-num">03</span>
        <h3>Deliver &amp; get paid</h3>
        <p>
          Pick up assigned tickets inside funded projects, ship the work,
          get paid per story point via Razorpay once it's accepted.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="pl-roles" id="pl-roles">
  <div class="pl-section-inner">
    <p class="pl-eyebrow pl-eyebrow-dark">OPEN ROLES</p>
    <h2 class="pl-section-title">Find where you fit.</h2>

    <div class="pl-roles-grid">
      <a
        *ngFor="let role of roles"
        class="pl-role-card"
        routerLink="apply"
        [queryParams]="{ role: role.role }"
      >
        <span class="pl-role-icon">
          <mat-icon>{{ role.icon }}</mat-icon>
        </span>
        <h3 class="pl-role-label">{{ role.label }}</h3>
        <p class="pl-role-tagline">{{ role.tagline }}</p>
        <p class="pl-role-desc">{{ role.description }}</p>
        <span class="pl-role-cta">
          Apply as {{ role.label }}
          <mat-icon>arrow_forward</mat-icon>
        </span>
      </a>
    </div>
  </div>
</section>

<section class="pl-bar">
  <div class="pl-section-inner pl-bar-inner">
    <p class="pl-eyebrow pl-eyebrow-light">THE BAR</p>
    <h2 class="pl-bar-title">We turn most applications down. On purpose.</h2>
    <p class="pl-bar-sub">
      Buyers pay a fixed price expecting a finished, working result — not a
      bet on who shows up. Every Execution Partner is reviewed by hand
      before they can pick up a single ticket. If you're proud of your
      work, this is where that pays off.
    </p>
    <ul class="pl-bar-list">
      <li><mat-icon>check_circle</mat-icon> Real work reviewed, not just a resume skim</li>
      <li><mat-icon>check_circle</mat-icon> Fixed pricing per story point — no bidding, no lowballing</li>
      <li><mat-icon>check_circle</mat-icon> Payouts via Razorpay once work is buyer-accepted</li>
    </ul>
  </div>
</section>

<section class="pl-final-cta">
  <div class="pl-section-inner pl-final-cta-inner">
    <h2>Ready to apply?</h2>
    <p>It takes about 10 minutes — bring your best work.</p>
    <a routerLink="apply" class="pl-btn pl-btn-primary pl-btn-lg">
      Become an Execution Partner
      <mat-icon>arrow_forward</mat-icon>
    </a>
  </div>
</section>